<div class="login-page">
  <div class="left-section">
    <div class="left-content">
      <h1 class="intro-title">{{signInWelcomeTextLabel}}</h1>
      <p class="intro-label">{{signInDescription}}</p>
      <div class="login-feature-list">
        <div class="login-feature-item feature-operations">
          <span class="login-feature-icon">
            <img src="/assets/images/temp/calander_upcomming-2.svg" alt="" aria-hidden="true" />
          </span>
          <span class="login-feature-text login-feature-text--two-lines" translate>label_feature_efficient_operations</span>
        </div>
        <div class="login-feature-item feature-passenger">
          <span class="login-feature-icon">
            <img src="/assets/images/temp/car_fill.svg" alt="" aria-hidden="true" />
          </span>
          <span class="login-feature-text" translate>label_feature_passenger_experience</span>
        </div>
        <div class="login-feature-item feature-fleet">
          <span class="login-feature-icon">
            <img src="/assets/images/temp/Multiple_User.svg" alt="" aria-hidden="true" />
          </span>
          <span class="login-feature-text" translate>label_feature_fleet_management</span>
        </div>
        <div class="login-feature-item feature-data">
          <span class="login-feature-icon">
            <img src="/assets/images/temp/chart_icon.svg" alt="" aria-hidden="true" />
          </span>
          <span class="login-feature-text login-feature-text--two-lines" translate>label_feature_data_driven</span>
        </div>
      </div>
    </div>
    <div class="login-banner-img">
      <img src="/assets/images/temp/login-banner.png" alt="Executive transportation at a business event">
    </div>
    <div class="login-left-slogan" translate>label_safe_journeys_slogan</div>
  </div>

  <div class="right-section">
    <div class="signin-box-inner-container">
      <div class="login-right-header">
        <div class="brand-right-logo">
          <img class="right-logo-style" [src]="logoPath" alt="">
        </div>
        <div class="sign-in-text">
          <h2 class="welcome-back">{{welcomeBackLabel}}</h2>
          <p class="sign-in-subtitle">{{signInPortalSubtitle}}</p>
        </div>
      </div>

      <div class="login-scroll-area">
        <div class="login-card">
          <app-login
            [isSigningIn]="isSigningIn"
            (onSignInEmitter)="doSignIn($event)"
            (onOtpSignInEmitter)="doOtpSignIn($event)"
            (onForgotPasswordEmitter)="forgotPassword()">
          </app-login>
        </div>
      </div>

      <div class="powered-by-footer">
        <a [href]="signInService.poweredByRedirectBeforeLoginUrl" target="_blank">
          <img id="mi_logo" [src]="poweredByBeforeLogoUrl" alt="">
        </a>
      </div>
    </div>
  </div>
</div>

<p-dialog [modal]="true" [draggable]="false" [resizable]="false" appendTo="body"
  styleClass="login-page-dialog" position="center" [(visible)]="forgotPopup"
  [closable]="false" [baseZIndex]="12000" [autoZIndex]="true"
  [style]="{ width: '420px', maxWidth: '92vw' }">
  <ng-template pTemplate="header">
    <span id="labelResetPassword">{{labelResetPassword}}</span>
  </ng-template>
  <app-forgot-password (onPopClose)="onPopClose($event)" (onPopSave)="onPopSave($event)"></app-forgot-password>
</p-dialog>

<p-dialog [modal]="true" [draggable]="false" [resizable]="false" appendTo="body"
  styleClass="login-page-dialog" position="center" [(visible)]="otpPopup"
  [closable]="false" [baseZIndex]="12000" [autoZIndex]="true"
  [style]="{ width: '420px', maxWidth: '92vw' }">
  <ng-template pTemplate="header">
    <span id="labelValidateOtp">{{labelValidateOtp}}</span>
  </ng-template>
  <app-otp-verifiy [email]="otpEmail" [phone]="otpPhone" (onOtpPopClose)="onOtpPopClose($event)"
    (onOtpPopSave)="onOtpPopSave($event)"></app-otp-verifiy>
</p-dialog>

<p-dialog [modal]="true" [draggable]="false" [resizable]="false" appendTo="body"
  styleClass="login-page-dialog" position="center" [(visible)]="setPasswordPopup"
  [closable]="false" [baseZIndex]="12000" [autoZIndex]="true"
  [style]="{ width: '420px', maxWidth: '92vw' }">
  <ng-template pTemplate="header">
    <span id="labelResetPassword">{{labelResetPassword}}</span>
  </ng-template>
  <app-set-password [otpId]="otpId" (onSetPasswordPopClose)="onSetPasswordPopClose($event)"></app-set-password>
</p-dialog>
